import React from "react";
import Black from "../../../../assets/images/game_gozine.png";
import Yellow from "../../../../assets/images/game_gozine_select.png";
import Grid from "@material-ui/core/Grid";
class QuestionAnswer extends React.Component{
    constructor() {
        super();
        this.state={
            buttonImage:Black,
        }
    }
    changeButtonImage=()=>{
        const alreadyAnswered=this.props.checkAnswered()
        if (!alreadyAnswered)
            this.setState({
                buttonImage:Yellow
            })
    }
    render() {
        const {data}=this.props
        const buttonImage=this.state.buttonImage
        return(
            <Grid onClick={()=>{
                this.changeButtonImage()
            }} alignItems={"center"} justify={"center"} item container style={{position:'relative'}}>
                <img src={buttonImage} style={{width:'80%'}} alt=""/>
                <p style={{position:'absolute',color:'#ffffff'}}>
                    {data.text}
                </p>
            </Grid>

        )
    }
}
export default QuestionAnswer